import { render, staticRenderFns } from "./GuestbookNavigation.vue?vue&type=template&id=261aa283&scoped=true&"
import script from "./GuestbookNavigation.vue?vue&type=script&lang=js&"
export * from "./GuestbookNavigation.vue?vue&type=script&lang=js&"
import style0 from "./GuestbookNavigation.vue?vue&type=style&index=0&id=261aa283&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261aa283",
  null
  
)

export default component.exports